import _ from 'lodash';

const Utils = {

  apiUrl: (path) => process.env.REACT_APP_API_URL+'api/'+path,

  apiHeaders: (extraparams = null) => {
    let headers = {
      "headers": {        
        //"apikey": "ZWEyYjVlZGNkYTMyMTA3OWRiYjhmNTkzYTRkMzNkNjc=",
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",        
        "Access-Control-Allow-Methods": "PUT,GET,POST,DELETE,OPTIONS,PATCH",        
        'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token, token, access-control-allow-origin',
        'Accept': 'application/json, text/plain, */*'
      }
    };

    const uData = Utils.getUserData();    
    if(uData && _.get(uData,'token',false)){
      headers['headers']['token']=uData.token;
    }

    if(extraparams){
      headers = { ...headers, ...extraparams}; 
    }
    return headers;
  },


  isLoggedIn: () => {
    const dt = Utils.getUserData();    
    return _.get(dt,'token',false)!==false;
  },

  removeSession: () => {
    let dt = Utils.getUserData();
    // console.log(dt, "session data")
    dt.token = false;
    // const backup = localStorage.getItem(process.env.REACT_APP_APPNAME + '-userData');    
    localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData',JSON.stringify(dt));    
  },

  getUserData: () => {
    let userData = localStorage.getItem(process.env.REACT_APP_APPNAME + '-userData');    
    if(userData){
      return JSON.parse(userData);

    }else{
      return false;
    }
  },

  setUserData: (data) => {    
    const uData = _.get(data,'data',false);
    // return;
    if(uData===false){
      //=== logout
      localStorage.removeItem(process.env.REACT_APP_APPNAME + '-userData');
    }else{
      let userData = Utils.getUserData();
      if(!userData){
        userData = {}; 
      }
      uData['token']=_.get(data,'token',false);
      uData[`stepData${userData.id}`] = userData[`stepData${userData.id}`];
      userData = {...userData,...uData};
      localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData',JSON.stringify(userData));
    }
  },

  saveUserData: (data, stepData) => {
    if(_.get(data, 'token', false )){     
      data[`stepData${data.id}`] = stepData;
     localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData',JSON.stringify(data));
    }
  },

  setStepData: (stepData) =>{
    let userData = Utils.getUserData();
    userData[`stepData${userData.id}`] = stepData;
  },

  setCourseType: (courseType) => {
    let userData = Utils.getUserData();
    userData = {...userData, courseType: courseType};    
    localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData', JSON.stringify(userData));
  },

  getCourseType: () => {
    let  userData = Utils.getUserData();
    return _.get(userData, 'courseType', false);
  },

  getStepData: () => {
    let userData = Utils.getUserData();
    return _.get(userData, `stepData${userData.id}`, false);
  },

  saveSlides: (data, slide) => {
    let userData = Utils.getUserData();
    if(_.get(data, 'token', false)){       
      userData = {...userData, stepData:slide.stepData,  slides: slide.slides};      
      localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData', JSON.stringify(userData));
    }
  },

  addToUserData: (data) => {
    let userData = Utils.getUserData();
    if(!userData){
      userData = {}; 
    }
    userData = {...userData,...data};
    localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData',JSON.stringify(userData));
  },

  loadJS: (src, failedmsg) => {
    return new Promise((resolve,reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            reject(failedmsg);
        };
        document.body.appendChild(script);
    });
  },

  questionType: [
    'Single Choice',
    'Multi Choice'
  ],

  questionTypeControl: [
    'radio',
    'checkbox'
  ],

  countries: [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bonaire",
    "Bosnia & Herzegovina",
    "Botswana",
    "Brazil",
    "British Indian Ocean Ter",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Canary Islands",
    "Cape Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Channel Islands",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos Island",
    "Colombia",
    "Comoros",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "Cote DIvoire",
    "Croatia",
    "Cuba",
    "Curacao",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Ter",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Great Britain",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guinea",
    "Guyana",
    "Haiti",
    "Hawaii",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "Indonesia",
    "India",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea North",
    "Korea South",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macau",
    "Macedonia",
    "Madagascar",
    "Malaysia",
    "Malawi",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Midway Islands",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Nambia",
    "Nauru",
    "Nepal",
    "Netherland Antilles",
    "Netherlands (Holland, Europe)",
    "Nevis",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau Island",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn Island",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Republic of Montenegro",
    "Republic of Serbia",
    "Reunion",
    "Romania",
    "Russia",
    "Rwanda",
    "St Barthelemy",
    "St Eustatius",
    "St Helena",
    "St Kitts-Nevis",
    "St Lucia",
    "St Maarten",
    "St Pierre & Miquelon",
    "St Vincent & Grenadines",
    "Saipan",
    "Samoa",
    "Samoa American",
    "San Marino",
    "Sao Tome & Principe",
    "Saudi Arabia",
    "Senegal",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Tahiti",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks & Caicos Is",
    "Tuvalu",
    "Uganda",
    "United Kingdom",
    "Ukraine",
    "United Arab Emirates",
    "United States of America",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City State",
    "Venezuela",
    "Vietnam",
    "Virgin Islands (Brit)",
    "Virgin Islands (USA)",
    "Wake Island",
    "Wallis & Futana Is",
    "Yemen",
    "Zaire",
    "Zambia",
    "Zimbabwe"
  ]
};

export default Utils;

